import React, { useEffect, useState } from 'react';
import useStyle from './percentPicker.style';
import { IconButton } from '../../Buttons/IconButton';

export const PercentPicker = ({
  defaultValue = 0,
  handleChange
}: {
  defaultValue?: number;
  handleChange?: (number) => void;
}) => {
  const [value, setValue] = useState<number>(0);
  const classes = useStyle();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChangeValue = type => {
    if (type === 'minus' && value !== 0) {
      setValue(value - 5);
      handleChange(value - 5);
    }
    if (type === 'plus' && value !== 100) {
      setValue(value + 5);
      handleChange(value + 5);
    }
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={() => handleChangeValue('minus')}
        icon={'Minus'}
        variant="backless"
      />
      <p className={classes.percent}>{value}%</p>
      <IconButton
        onClick={() => handleChangeValue('plus')}
        icon={'Plus'}
        variant="backless"
      />
    </div>
  );
};
